module.exports = __webpack_public_path__ + "static/media/8-Y.a0d00ac5.mp3";